export default {
  wrapper: {
    position: 'relative',
    maxWidth: '400px',

    '@media screen and (max-width: 600px)': {
      alignItems: 'center',
      width: '90%',
    },
  },
  container: {
    padding: '50px',
    background: '#fff',
    borderRadius: '4px',

    '@media screen and (max-width: 600px)': {
      padding: '25px',
    },
  },
  heading: {
    marginBottom: '60px',
    fontSize: '32px',
    lineHeight: '37px',
    fontWeight: 'bold',
    textAlign: 'center',

    '@media screen and (max-width: 600px)': {
      marginBottom: '25px',
      fontSize: '24px',
      lineHeight: '28px',
    },
  },
  buttonContainer: {
    maxWidth: '70%',
    marginTop: '40px',

    '@media screen and (max-width: 600px)': {
      maxWidth: '90%',
      marginTop: '20px',
    },
  },
  inputContainer: {
    padding: '8px 0',
  },
};
